import React from 'react';
import styles from './styles/GlobalStyles.module.css';

function Impressum() {
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.mainHeading}>Impressum</h1>
      </div>

      {/* Impressumstext */}
      {/* Impressumstext mit zwei Spalten innerhalb von `.section` */}
      <div className={styles.section}>
        <div className={styles.flexContainer}>
          {/* Inhaber-Angaben */}
          <div className={styles.flexItem}>
            <h3 className={styles.heading}>Inhaber</h3>
            <p className={styles.paragraph}>
              Sebastian Gessenharter<br />
              Hochstiftsweg 6 <br />
              94113 Tiefenbach<br />
              Deutschland<br />
              <a href="mailto:gessenharter@yahoo.com">Kontakt</a>
            </p>
          </div>

          {/* Programmierung / Webdesign */}
          <div className={styles.flexItem}>
            <h3 className={styles.heading}>Programmierung / Webdesign</h3>
            <p className={styles.paragraph}>
              Martin Fendl<br />
              Deutschland<br />
              <a href="mailto:martinfendl@gmail.com">Kontakt</a>
            </p>
          </div>
        </div>

        {/* Haftung für Inhalte */}
        <p className={styles.paragraph}>
          <strong>Haftung für Inhalte:</strong><br />
          Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>

        {/* Haftung für Links */}
        <p className={styles.paragraph}>
          <strong>Haftung für Links:</strong><br />
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>

        {/* Urheberrecht */}
        <p className={styles.paragraph}>
          <strong>Urheberrecht:</strong><br />
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Webseite unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Webseite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>

        {/* Quellenangabe */}
        <p className={styles.paragraph}>
          <strong>Quelle:</strong> <a href="http://www.e-recht24.de" target="_blank" rel="noopener noreferrer">
            e-recht24.de
          </a>
        </p>

      </div>
    </div>
  );
}

export default Impressum;
